import { Box, XStack, YStack } from '@/components/ui/layout/layout';
import type { CodingAgentId } from '@/features/electron-api/features/CodingAgentsAPI';

import { AgentLogo } from './agent-logos';

import type { ReactNode } from 'react';

/** An agent's row: its logo and name, the lines below the name, and the controls on the right */
export const AgentRow = ({
  id,
  label,
  children,
  actions,
}: {
  id: CodingAgentId;
  label: string;
  children: ReactNode;
  actions?: ReactNode;
}) => (
  <XStack
    data-testid={`coding-agent-row-${id}`}
    className="items-center justify-between gap-6 rounded-lg border border-border bg-surface px-4 py-3.5"
  >
    <XStack className="min-w-0 flex-1 items-center gap-3.5">
      <Box className="grid size-10 shrink-0 place-items-center rounded-[0.45rem] border border-border bg-background">
        <AgentLogo id={id} className="size-6" />
      </Box>
      <YStack className="min-w-0 flex-1 gap-1">
        <p className="text-sm font-medium text-foreground">{label}</p>
        {children}
      </YStack>
    </XStack>
    <XStack className="shrink-0 items-center gap-2">{actions}</XStack>
  </XStack>
);
